import React, { useEffect, useState } from "react";

import { observer } from "mobx-react";
import { Col, Row } from "react-bootstrap";

import { BottomsheetDropdown } from "components";
// import Utils from "./utils";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";

const ZindagiProtect = (props) => {
  const { form, data } = props;

  return (
    <div className=''>
      <div className='mx-0 my-4'>
        {/* <Col md={6} className='col-12 mb-3'> */}
        {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
        {/* <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("policy-term").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("policy-term").label}
          menuList={form.$("policy-term").extra.optionList}
          value={form.$("policy-term").value}
          onSelect={(e) => form.$("policy-term").extra.onChangePolicyTerm(e, form, data.data)}
          disabled={false}
        />
        {/* </div> */}
        {/* </Col> */}
      </div>
      <div className='mx-0 my-4'>
        {/* <Col md={6} className='col-12 mb-3'> */}
        {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
        {/* <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-term").label}</div> */}
        <BottomsheetDropdown
          dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
          menuItemStyle='d-flex justify-content-between align-items-center'
          selectedLabelKey='label'
          bottomsheetTitle={form.$("premium-term").label}
          menuList={form.$("premium-term").extra.optionList}
          value={form.$("premium-term").value}
          disabled={form.$("premium-term").disabled}
          onSelect={(e) => form.$("premium-term").extra.onChangePremiumTerm(e, form, data.data)}
        />
        {/* </div> */}
        {/* </Col> */}
      </div>

    </div>
  );
};

export default observer(ZindagiProtect);
